import { render, staticRenderFns } from "./Audits.vue?vue&type=template&id=0288ba8c&scoped=true"
import script from "./Audits.vue?vue&type=script&lang=js"
export * from "./Audits.vue?vue&type=script&lang=js"
import style0 from "./Audits.vue?vue&type=style&index=0&id=0288ba8c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0288ba8c",
  null
  
)

export default component.exports